<template>
  <button
      class="btn orcaBtn"
      style="min-width:150px;background-color:red;"
      :disabled="adminBusy"
      @click="run"
      type="button"
  >
    <span v-if="!adminBusy">{{ hard ? 'Force ' : '' }}Reset</span>
    <span v-else>Working...</span>
  </button>
</template>

<script>
export default {
  name: "AdminResetSiteButton",

  props: {
    companyId: { required: true },
    siteId:    { required: true },
    period:    { required: true },
    adminBusy: { type: Boolean, required: true },
    withAdminLock: { type: Function, required: true },
    success: { type: Function, required: true },
    hard: { type: Boolean, default: false }
  },

  methods: {
    async doAction() {
      let url = `${this.crmApiPath}r3/admin/timesheets/company/${this.companyId}/reset/site/${this.siteId}?submission_date=${this.period}`;
      if (this.hard) {
        url += '&skip_fin=false';
      }
      await axios.post(url);
      this.$snotify?.success("Site reset!");
    },

    async run() {
      await this.withAdminLock(this.doAction)();
      await this.success();
    }
  }
};
</script>
